export const DOWNLOAD_HELP_DATA = [
    {
        id: "compatibilidad_soporte",
        textButton: {
            default: "Compatibilidad y soporte",
            translationPath: "descarga.compatibilidad_soporte.titulo",
        },
        contenido: [
            {
                type: "paragraph",
                default: "Esta nueva versión de MakeMake te permitirá una navegación más ágil y sencilla. Para su correcto funcionamiento, tu dispositivo debe cumplir con ciertos criterios como son la compatibilidad del navegador y del sistema operativo.",
                translationPath: "descarga.compatibilidad_soporte.p_uno",
            },
            {
                type: "paragraph",
                default: "Para un perfecto funcionamiento MakeMake te recomienda usar los siguientes navegadores en diferentes sistemas operativos.",
                translationPath: "descarga.compatibilidad_soporte.p_dos",
            },
            {
                type: "img",
                default: "/img/instrucciones/navegadores-recomendados.png",
                translationPath: "descarga.compatibilidad_soporte.img_uno",
            },
            {
                type: "paragraph",
                default: "Para la instalación de la aplicación consulta la compatibilidad de tu navegador y sistema operativo en la siguiente tabla:",
                translationPath: "descarga.compatibilidad_soporte.p_tres",
            },
            {
                type: "img",
                default: "./img/instrucciones/tabla-descarga-app.png",
                translationPath: "descarga.compatibilidad_soporte.img_dos",
            },
            {
                type: "paragraph",
                default: "Para la descarga de libros consulta la compatibilidad del navegador y el sistema operativo en la siguiente tabla:",
                translationPath: "descarga.compatibilidad_soporte.p_cuatro",
            },
            {
                type: "img",
                default: "./img/instrucciones/tabla-descarga-libros.png",
                translationPath: "descarga.compatibilidad_soporte.img_tres",
            },
            {
                type: "strong",
                default: "¿Cómo sé qué versión de navegador tengo?",
                translationPath: "descarga.compatibilidad_soporte.strong_uno",
            },
            {
                type: "title-list",
                default: "Chrome:",
                translationPath: "descarga.compatibilidad_soporte.u_uno",
            },
            {
                type: "list",
                name: "chrome-list",
                list: [
                    {
                        id: "opc-1",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_una.li_uno",
                    },
                    {
                        id: "opc-2",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_una.li_dos",
                    },
                    {
                        id: "opc-3",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_una.li_tres",
                    },
                    {
                        id: "opc-4",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_una.li_cuatro",
                    }
                ]
            },
            {
                type: "img",
                default: "./img/instrucciones/vs-chrome.png",
                translationPath: "descarga.compatibilidad_soporte.img_cuatro",
            },
            {
                type: "title-list",
                default: "Safari:",
                translationPath: "descarga.compatibilidad_soporte.u_dos",
            },
            {
                type: "list",
                name: "safari-list",
                list: [
                    {
                        id: "opc-1",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_dos.li_uno",
                    },
                    {
                        id: "opc-2",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_dos.li_dos",
                    },
                    {
                        id: "opc-3",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_dos.li_tres",
                    }
                ]
            },
            {
                type: "img",
                default: "./img/instrucciones/vs-safari.png",
                translationPath: "descarga.compatibilidad_soporte.img_cinco",
            },
            {
                type: "title-list",
                default: "Microsoft Edge:",
                translationPath: "descarga.compatibilidad_soporte.u_tres",
            },
            {
                type: "list",
                name: "microsoft-list",
                list: [
                    {
                        id: "opc-1",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_tres.li_uno",
                    },
                    {
                        id: "opc-2",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_tres.li_dos",
                    },
                    {
                        id: "opc-3",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_tres.li_tres",
                    },
                    {
                        id: "opc-4",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_tres.li_cuatro",
                    },
                    {
                        id: "opc-5",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_tres.li_cinco",
                    }
                ]
            },
            {
                type: "img",
                default: "./img/instrucciones/vs-edge.png",
                translationPath: "descarga.compatibilidad_soporte.img_seis",
            },
            {
                type: "title-list",
                default: "Mozilla Firefox:",
                translationPath: "descarga.compatibilidad_soporte.u_cuatro",
            },
            {
                type: "list",
                name: "mozilla-list",
                list: [
                    {
                        id: "opc-1",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_cuatro.li_uno",
                    },
                    {
                        id: "opc-2",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_cuatro.li_dos",
                    },
                    {
                        id: "opc-3",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_cuatro.li_tres",
                    },
                    {
                        id: "opc-4",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_cuatro.li_cuatro",
                    },
                    {
                        id: "opc-5",
                        translationPath: "descarga.compatibilidad_soporte.lista_ordenada_cuatro.li_cinco",
                    }
                ]
            },
            {
                type: "img",
                default: "./img/instrucciones/vs-firefox.png",
                translationPath: "descarga.compatibilidad_soporte.img_siete",
            },
            {
                type: "strong",
                default: "Nota: Si tienes una extensión para bloquear anuncios (ejemplo: adblock) funciones como la descarga, la lectura de libros offline y la instalación de la aplicación de MakeMake no estarán disponibles. Por favor desactívalo para un buen funcionamiento del sitio.",
                translationPath: "descarga.compatibilidad_soporte.strong_dos",
            }
        ]
    },
    {
        id: "como_descargo_libro",
        textButton: {
            default: "¿Cómo puedo descargar libros en MakeMake?",
            translationPath: "descarga.como_descargo_libro.titulo",
        },
        contenido: [
            {
                type: "strong",
                default: "Nota: Cada vez que ingreses a MakeMake, verás una barra en la parte inferior que indica el estado de la configuración de la descarga de libros y almacenamiento offline.",
                translationPath: "descarga.como_descargo_libro.strong_uno",
            },
            {
                type: "strong",
                default: "Si la barra es de color MORADO significa que aún no puedes descargar libros ni visualizarlos de manera offline.",
                translationPath: "descarga.como_descargo_libro.strong_dos",
            },
            {
                type: "img",
                default: "./img/instrucciones/conf-cargando.png",
                translationPath: "descarga.como_descargo_libro.img_uno",
            },
            {
                type: "strong",
                default: "Cuando la barra sea VERDE, significa que ya puedes descargar libros y verlos de manera offline.",
                translationPath: "descarga.como_descargo_libro.tres",
            },
            {
                type: "img",
                default: "./img/instrucciones/conf-cargado.png",
                translationPath: "descarga.como_descargo_libro.img_dos",
            },
            {
                type: "list",
                name: "descarga-list",
                list: [
                    {
                        id: "opc-1",
                        translationPath: "descarga.como_descargo_libro.lista_descargo_libro.li_uno",
                    },
                    {
                        id: "opc-2",
                        translationPath: "descarga.como_descargo_libro.lista_descargo_libro.li_dos",
                    },
                    {
                        id: "opc-3",
                        translationPath: "descarga.como_descargo_libro.lista_descargo_libro.li_tres",
                    },
                    {
                        id: "opc-4",
                        translationPath: "descarga.como_descargo_libro.lista_descargo_libro.li_cuatro_p",
                    }
                ]
            },
            {
                type: "link",
                url: "/descargados",
                default: "Descargas",
                translationPath: "descarga.como_descargo_libro.lista_descargo_libro.li_cuatro_a",
            },
            {
                type: "strong",
                default: "Nota: esta función de descarga que acabamos de describir no te obliga a bajar el app de MakeMake. Si quieres bajar el app de MakeMake para mayor facilidad de uso, continúa leyendo estas instrucciones.",
                translationPath: "descarga.como_descargo_libro.strong_cuatro",
            },
        ]
    },
    {
        id: "donde_encuentro_libros",
        textButton: {
            default: "¿Dónde encuentro los libros que tengo descargados?",
            translationPath: "descarga.donde_encuentro_libros.titulo",
        },
        contenido: [
            {
                type: "paragraph",
                default: "Podrás encontrar los libros descargados previamente en la barra superior expandiendo el botón 'Mi cuenta', en la opción Descargas'",
                translationPath: "descarga.donde_encuentro_libros.p_uno",
            },
            {
                type: "img",
                default: "./img/instrucciones/btns-descargas.png",
                translationPath: "descarga.donde_encuentro_libros.img_uno",
            },
            {
                type: "paragraph",
                default: "En esta sección verás:",
                translationPath: "descarga.donde_encuentro_libros.p_dos",
            },
            {
                type: "list",
                name: "descarga-libros-list",
                list: [
                    {
                        id: "opc-1",
                        translationPath: "descarga.donde_encuentro_libros.lista_ordenada_uno.li_uno",
                    },
                    {
                        id: "opc-2",
                        translationPath: "descarga.donde_encuentro_libros.lista_ordenada_uno.li_dos",
                    },
                    {
                        id: "opc-3",
                        translationPath: "descarga.donde_encuentro_libros.lista_ordenada_uno.li_tres",
                    }
                ]
            },
            {
                type: "paragraph",
                default: "MakeMake solo te deja descargar DOS libros a la vez, que tienen una duración máxima de OCHO días en tu sistema.",
                translationPath: "descarga.donde_encuentro_libros.p_tres",
            },
            {
                type: "strong",
                default: "Nota: Si ya has completado la lectura de los libros descargados, podrás eliminar el libro de tus descargas y abrirle espacio a otro recurso. Así mismo, si ya terminó el tiempo y deseas renovar el libro debes descargarlo nuevamente.",
                translationPath: "descarga.como_descargo_libro.strong",
            },
        ]
    },
    {
        id: "cuantos_libros",
        textButton: {
            default: "¿Cuántos libros puedo descargar y por cuánto tiempo los tengo disponibles?",
            translationPath: "descarga.cuantos_libros.titulo",
        },
        contenido: [
            {
                type: "paragraph",
                default: "Puedes descargar dos libros, los cuales estarán almacenados en la aplicación durante 15 días.",
                translationPath: "descarga.cuantos_libros.p_uno",
            },
        ]
    },
    {
        id: "que_pasa_libros",
        textButton: {
            default: "¿Qué pasa con los libros que tengo descargados si cierro la app o el navegador?",
            translationPath: "descarga.que_pasa_libros.titulo",
        },
        contenido: [
            {
                type: "paragraph",
                default: "Cuando cuentes con libros descargados, estos se guardarán en la app (si descargaste la app en tu dispositivo) o el navegador donde los descargaste. Esto quiere decir que, aunque cierres la app o tu navegador aún podrás leer los libros descargados.",
                translationPath: "descarga.que_pasa_libros.p_uno",
            },
            {
                type: "paragraph",
                default: "Ten en cuenta que los libros solamente estarán disponibles en el dispositivo donde han sido descargados. Te recomendamos verificar y administrar las descargas cuando cuentes con conexión a internet. Una vez estés offline, podrás ingresar únicamente a los contenidos descargados. La demás información de MakeMake estará inhabilitada.",
                translationPath: "descarga.que_pasa_libros.p_dos",
            },
        ]
    },
    {
        id: "no_puedo_instalar",
        textButton: {
            default: "¿Por qué no puedo instalar el app de MakeMake?",
            translationPath: "descarga.no_puedo_instalar.titulo",
        },
        contenido: [
            {
                type: "paragraph",
                default: "No puedes instalar el app de MakeMake por alguno de estos motivos:",
                translationPath: "descarga.no_puedo_instalar.p_uno",
            },
            {
                type: "list",
                name: "no-puedo-list",
                list: [
                    {
                        id: "opc-1",
                        translationPath: "descarga.no_puedo_instalar.lista_no_puedo.li_dos",
                    },
                    {
                        id: "opc-2",
                        translationPath: "descarga.no_puedo_instalar.lista_no_puedo.li_tres",
                    }
                ]
            },
        ]
    },
    {
        id: "donde_descargo",
        textButton: {
            default: "¿Dónde descargo el navegador Chrome?",
            translationPath: "descarga.donde_descargo.titulo",
        },
        contenido: [
            {
                type: "paragraph",
                default: "El navegador que más recomendamos para la navegación en MakeMake es Google Chrome. Es gratis, fácil de usar y el más popular a nivel mundial.",
                translationPath: "descarga.donde_descargo.p_uno",
            },
            {
                type: "paragraph",
                default: "Para descargarlo gratuitamente en tu computador puedes visitar esta página web:",
                translationPath: "descarga.donde_descargo.p_dos",
            },
            {
                type: "link",
                url: "",
                default: "https://www.google.com/chrome/",
                translationPath: "descarga.donde_descargo.a_uno",
            },
        ]
    }

]